import React from 'react'

export default function CoursesOnboardingCourseItem({
  course,
  isLoadingCourse,
  setSelectedCourse,
}) {
  return (
    <div className={`hover:no-underline coursecard hover:scale-105 duration-700 cursor-pointer ${isLoadingCourse ? 'pointer-events-none opacity-50' : ''}`}
      onClick={() => setSelectedCourse(course)}>
      <div className="course bg-white shadow-md p-2 flex flex-col items-center relative h-[100px]"
        style={{
          background: `linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0)),
          url(${course.image}) no-repeat center center / cover`,
        }}
      >
        <div className="text-[20px] leading-none font-title mb-2 text-center text-white">{course.title.rendered}</div>
        <div className='absolute bottom-0 inset-x-0 text-center bg-red-500 text-white font-title'>See this course</div>
      </div>
    </div>
  )
}
